import { render, staticRenderFns } from "./CountryAdmin.vue?vue&type=template&id=7422b547&"
import script from "./CountryAdmin.vue?vue&type=script&lang=js&"
export * from "./CountryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports